import React from "react";
import classes from "./index.module.scss";

const SFLoadingRenderer = (props) => {
  return (
    <div
      className={classes.loader}
    >
      {/* we could add a loading gif here */}
      <span> {props.loadingMessage}</span>
    </div>
  );
};

export default SFLoadingRenderer;
